import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';
import { Button } from 'shared/ui/Button';
import { useModalsActions } from 'shared/ui/SideModal';
import { AlertBox } from 'shared/ui/AlertBox';
import { useGetCampaignNotes } from 'entities/campaign';
import { Note } from 'shared/ui/Note';

import { ShowNotesModal } from './ShowNotesModal';

interface ShowNotesProps {
  campaignId: number;
}

export function ShowNotes({ campaignId }: ShowNotesProps) {
  const { open } = useModalsActions();
  const getNotesQuery = useGetCampaignNotes(campaignId);
  const notesData = getNotesQuery.data?.data || [];

  const openNotesModal = () => {
    open(<ShowNotesModal campaignId={campaignId} />);
  };

  return (
    <>
      <div className="my-8 border-t border-slate-100" />
      <div className="mb-4 flex items-center justify-between">
        <div className="text-lg font-semibold">Notes</div>
        <Button
          dataTestId="button-show-all-notes"
          type="button"
          onClick={openNotesModal}
          variant="outline"
          size="medium"
          {...getDataAutoTestAttributes(['button-show-all-notes'])}
        >
          See all
        </Button>
      </div>
      {notesData.length === 0 ? (
        <AlertBox
          iconClass="text-deep-blue-500"
          iconName="info"
          className="border-deep-blue-100"
        >
          <div className="mb-2 font-semibold text-slate-900">Notes have not been added</div>
          <div className="text-slate-700">To add notes, click on 'See all'.</div>
        </AlertBox>
      ) : (
        <>
          <Note
            showDate={false}
            showHeader={false}
            lineNumToTruncate={5}
            {...notesData[0]}
          />
          <div className="text-xs leading-[20px] text-slate-600">
            {notesData.length > 1 && `+${notesData.length - 1} more`}
          </div>
        </>
      )}
    </>
  );
}
